import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProfileResidenceResponse, findResidenceOwnershipStatusById } from '../../models/profile-residence.model';
import { Store } from '@ngrx/store';
import { ProfileService } from '../../services/profile.service';
import { CurrencyPipe } from '@angular/common';
import { getProfileResidenceActions, getProfileResidenceClearActions } from '../../store/actions/profile.actions';
import { take } from 'rxjs/operators';
import { FormTracking } from '../../../../config/eev-form-tracking.config';
import { AuthFormName } from '../../../../enums/event/event-data.enum';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { DLEntry } from '../../../shared/models/description-list-entry.model';

@Component({
    selector: 'app-confirm-residence-change-modal',
    templateUrl: './confirm-residence-change-modal.component.html',
    styleUrls: ['./confirm-residence-change-modal.component.scss'],
    standalone: false
})
export class ConfirmResidenceChangeModalComponent implements OnInit {
  residenceFormTrackingConfig = FormTracking[AuthFormName.PROFILE_RESIDENCE_EDIT];
  isSubmitted = false;
  submissionError = false;
  isSubmitting = false;
  entries: DLEntry[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProfileResidenceResponse,
    private readonly store: Store,
    public dialogRef: MatDialogRef<ConfirmResidenceChangeModalComponent>,
    private readonly currencyPipe: CurrencyPipe,
    private readonly profileService: ProfileService,
    private readonly eventTrackingService: EventTrackingService
  ) {}

  buildEntries() {
    return [
      {
        label: 'Ownership Status',
        value: findResidenceOwnershipStatusById(this.data.ownershipStatusId),
      },
      {
        label: 'Monthly Payment',
        value: this.currencyPipe.transform(this.data.monthlyPayment, 'USD', 'symbol', '1.2-2'),
      },
    ];
  }

  ngOnInit(): void {
    this.entries = this.buildEntries();
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  updateResidence() {
    this.isSubmitting = true;

    this.profileService
      .updateProfileResidence(this.data)
      .pipe(take(1))
      .subscribe({
        next: (residence) => {
          if (residence.status === 'success') {
            this.isSubmitting = false;
            this.isSubmitted = true;
          } else {
            this.isSubmitting = false;
            this.submissionError = true;
          }

          setTimeout(() => {
            this.store.dispatch(getProfileResidenceClearActions());
            this.store.dispatch(getProfileResidenceActions());
            this.dialogRef.close();
          }, 2000);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.submissionError = true;
        },
      });
  }
}
